import { begin } from '../shared/functions'
import { defineCustomElement, ref, computed, watch } from 'vue/dist/vue.esm-bundler.js'
import { html } from './shared/functions'

const ImComponent = defineCustomElement({
  props: {
    value: {
      type: String,
      default: "",
    },
    mermaidAlign: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      mermaidId: `mermaid-${parseInt(Math.random() * 99999999, 10)}`,
      mermaidSvg: '',
    }
  },
  async mounted() {
    const { default: mermaid } = await import('https://cdn.jsdelivr.net/npm/mermaid@11.3.0/dist/mermaid.esm.min.mjs')
    mermaid.initialize({
      startOnLoad: false,
      securityLevel: 'loose',
      theme: 'base',
      themeVariables: {
        fontSize: '16px',
        primaryColor: '#d1fae5',
        primaryTextColor: '#374151',
        primaryBorderColor: '#d1fae5',
        lineColor: '#9ca3af',
        secondaryColor: '#f9fafb',
        tertiaryColor: '#f9fafb',
        nodeBorder: '#f0fdf4',
      }
    });

    mermaid.render(this.mermaidId, this.value)
      .then(result => {
        const svgString = begin(() => {
          switch (this.mermaidAlign) {
            case 'left':
              return `<div role="mermaid-align" style="width:fit-content; margin: 0 auto 0 0;">${result.svg}</div>`
            case 'center':
              return `<div role="mermaid-align" style="width:fit-content; margin: 0 auto;">${result.svg}</div>`
            case 'right':
              return `<div role="mermaid-align" style="width:fit-content; margin: 0 0 0 auto;">${result.svg}</div>`
            default:
              return result.svg;
          }
        })
        this.mermaidSvg = svgString;
      })
      .catch(error => {
        console.error("Mermaid 렌더링 오류:", error);
      })
  },
  template: html`<div class="mermaid" v-html="mermaidSvg"></div>`,
}, { shadowRoot: false })

customElements.define('im-mermaid-view', ImComponent)
